
import { useEffect } from "react";
import { useCacheManager } from "./useCacheManager";

/**
 * Hook to handle prefetching of next page of services
 */
export const usePrefetchServices = (
  result: any,
  page: number,
  isLowData: boolean,
  searchQuery: string,
  activeSubcategoryId: number | null,
  selectedRegion: string,
  adjustedPageSize: number,
  queryVersion: string,
  regionData: any,
  fetchServicePage: Function,
  prefetchNextPage: Function,
  prefetchedPagesRef: React.MutableRefObject<Set<number>>
) => {
  useEffect(() => {
    if (result.isSuccess && result.data?.totalPages > page && !isLowData) {
      const nextPage = page + 1;
      
      // Only prefetch if not already prefetched
      if (!prefetchedPagesRef.current.has(nextPage)) {
        const timer = setTimeout(() => {
          prefetchNextPage(
            nextPage,
            searchQuery,
            activeSubcategoryId,
            selectedRegion,
            adjustedPageSize,
            queryVersion,
            regionData,
            fetchServicePage
          );
        }, 1000);
        return () => clearTimeout(timer);
      }
    }
  }, [
    result.isSuccess, 
    result.data?.totalPages, 
    page, 
    searchQuery,
    activeSubcategoryId,
    selectedRegion,
    adjustedPageSize,
    isLowData,
    prefetchNextPage,
    regionData,
    fetchServicePage,
    prefetchedPagesRef,
    queryVersion
  ]);
};
